module.exports = __webpack_public_path__ + "static/media/acto_de_grado_7.511bf2f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_7.jpg
// module id = 914
// module chunks = 0